import { useContext } from 'react';
import { LangContext } from '@/context/LangProvider';
import { Input } from '@/components/ui/input';
import useWorkspaceRoles from '@/hooks/useWorkspaceRoles';
import { cn } from '@/lib/utils';
import { ProjectShareMaxRespondentsProps } from '@/types';
import RequiredLabel from '@/components/labels/RequiredLabel';

function ProjectShareMaxRespondets({
  singleProjectData,
  register,
  errors,
  setValue,
  setIsFormChanged,
}: ProjectShareMaxRespondentsProps) {
  const { lang } = useContext(LangContext);
  const { isUserViewer } = useWorkspaceRoles();

  const currentRespondents = singleProjectData?.respondents_max || 0;
  const errorMessage = errors?.respondents_max?.message;
  const hasError = !!errorMessage;

  const translatedError =
    errorMessage === 'msg.numberMustBeGreaterThanOrEqualTo'
      ? `${lang.get(errorMessage)} ${currentRespondents}`
      : lang.get(errorMessage);

  return (
    <RequiredLabel
      title="maximumNumberOfParticipants"
      tooltip={lang.get('msg.maximumNumberOfParticipantsTooltip')}
    >
      <Input
        type="number"
        disabled={isUserViewer}
        {...register('respondents_max', {
          setValueAs: (value: string) => (value === '' ? undefined : Number(value)),
        })}
        placeholder="Add maximum number of participants"
        hasError={!!errors?.respondents_max?.message}
        onChange={(e) => {
          setIsFormChanged(true);
          setValue('respondents_max', e.target.value, {
            shouldDirty: true,
            shouldValidate: true,
          });
        }}
      />

      <p className={cn(hasError ? 'flex' : 'hidden', 'text-red-600 text-xs font-semibold')}>
        {hasError && <p className="flex text-red-600 text-xs font-semibold">{translatedError}</p>}
      </p>
    </RequiredLabel>
  );
}

export default ProjectShareMaxRespondets;
